import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@dune/ui";
import React, { useEffect } from "react";
import {
	useGetDuneSignatories,
	useMe,
} from "../../api/queries/users.queries";

interface DuneSignatorySelectProps {
	value: string;
	onValueChange: (value: string) => void;
	disabled?: boolean;
	id?: string;
	defaultToCurrentUser?: boolean;
}

const DuneSignatorySelect: React.FC<DuneSignatorySelectProps> = ({
	value,
	onValueChange,
	disabled = false,
	id = "signatory-select",
	defaultToCurrentUser = false,
}) => {
	const { data: duneSignatories, isLoading: isLoadingSignatories } =
		useGetDuneSignatories();
	const { me } = useMe();

	useEffect(() => {
		if (
			defaultToCurrentUser &&
			me &&
			duneSignatories &&
			!value
		) {
			const currentUserSignatory = duneSignatories.find(
				(signatory) => signatory.id === me.id,
			);
			if (currentUserSignatory) {
				onValueChange(currentUserSignatory.id.toString());
			}
		}
	}, [defaultToCurrentUser, me, duneSignatories, value, onValueChange]);

	return (
		<div className="space-y-2">
			<label htmlFor={id} className="text-sm font-medium">
				Signataire Dune
			</label>
			<Select
				value={value}
				onValueChange={onValueChange}
				disabled={disabled || isLoadingSignatories || !duneSignatories?.length}
			>
				<SelectTrigger id={id}>
					<SelectValue
						placeholder={
							isLoadingSignatories
								? "Chargement..."
								: !duneSignatories?.length
									? "Aucun signataire disponible"
									: "Sélectionnez un signataire"
						}
					/>
				</SelectTrigger>
				<SelectContent>
					{duneSignatories?.map((signatory) => (
						<SelectItem
							key={signatory.id}
							value={signatory.id.toString()}
						>
							{signatory.firstname} {signatory.lastname}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
};

export default DuneSignatorySelect;
